import React from 'react'

import transformLink from '~/utils/transformLink'

import ButtonArrow from '~/components/core/buttonArrow'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'

const ImageTextProfile = ({ data }) => {
  data = data.fields ? data.fields : data

  const content = data.content
  const cta = data.cta ? (data.cta.fields ? data.cta.fields : data.cta) : null
  let contentTypeContentful, url

  if (cta) {
    let ctaContent = transformLink(cta, true, false)
    contentTypeContentful = ctaContent.contentTypeContentful
    url = ctaContent.url
  }

  let imgId

  switch (data.icon) {
    case 'Homme':
      imgId = 'man'
      break
    case 'Personnes':
      imgId = 'people'
      break
    case 'Ville':
      imgId = 'city'
      break
    case 'Travaux':
      imgId = 'works'
      break
    default:
      break
  }

  return (
    <div className="col-12 lg-col-10 mx-auto">
      <div
        className={`bg-light-blue pt-8 ${!imgId ? 'pb-8' : ''} md:py-20 px-6 md:px-10 lg:px-0 image-text-profile`}
      >
        <div className="md-col-7 lg-col-4 lg-col-offset-1">
          <h2 className="title-2-bold mb-4 md:mb-6">{data.title}</h2>

          <Wysiwyg document={content} classes={cta ? 'mb-7' : ''} />

          {cta && (
            <ButtonArrow
              text={cta.label}
              link={url}
              contentType={contentTypeContentful}
              color="blue"
            />
          )}

          {imgId && (
            <img
              alt=""
              src={`/img/profile/profile-${imgId}.svg`}
              className={`image-text-profile__icon-${imgId}`}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ImageTextProfile
